import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function TermsMiddleware({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const termsAccepted = localStorage.getItem("termsAccepted") === "true";
    const roleName = localStorage.getItem("roleName");

    const isAdminUser =
      localStorage.getItem("roleType") === "ADMIN" ||
      localStorage.getItem("isMaster") === "true" ||
      roleName === "Comando";

    // Se o usuário não aceitou os termos e não está na página de termos, redireciona
    if (
      !termsAccepted &&
      !["/termos-de-uso", "/login"].includes(location.pathname)
    ) {
      if (!isAdminUser) {
        navigate("/termos-de-uso");
      }
    }
  }, [location.pathname, navigate]);

  return children;
}
